import { useLocation } from "react-router-dom";
import { DataTableCol } from "../../../components/data-table/types";

export const OrganizationDataGridCols = (): DataTableCol[] => {
    const location = useLocation();
    return [
        {
            title: 'Business Unit Name',
            control: 'business_name',
            sortable: true,
            isLink: location.pathname === "/dashboard/subscriptions" ? false : true,
            canShowColumn: true
        },
        {
            title: 'Business Head',
            control: 'head_of_business',
            sortable: true,
            canShowColumn: true
        },
        {
            title: 'Phone Number',
            control: 'contact_number',
            sortable: true,
            canShowColumn: true
        },
        {
            title: 'Register Date',
            control: 'created_date',
            sortable: true,
            canShowColumn: true
        },
        {
            title: 'Products',
            control: 'productCount',
            sortable: true,
            canShowColumn: true
        },
        {
            title: 'Total Retail Invoices',
            control: 'totalRetailInvoices',
            sortable: false,
            canShowColumn: true
        },
        {
            title: 'Total Transaction Invoices',
            control: 'totalTransactionsInvoices',
            sortable: false,
            canShowColumn: true
        },
        // {
        //     title: 'Revenue',
        //     control: 'revenue',
        //     sortable: true,
        //     // canShowColumn: true
        // },
        {
            title: 'Users',
            control: 'users_count',
            sortable: true,
            canShowColumn: true
        },
        ...(location.pathname === "/dashboard/subscriptions"
            ? [
                {
                    title: 'Actions',
                    control: 'action',
                    isView : true,
                    canShowColumn: true
                }
            ]
            : []),
    ]
};